import React, { useEffect, useState } from 'react'
import { Button, Modal, Table, Icon } from 'semantic-ui-react'
import axios from 'axios'
import moment from "moment";
import { userId, customerNo, DDMMYYYYHHmmss } from "../../utils/constant";
import { statusHistory } from '../../utils/componentColumnConstants';
function StatusHistory(props) {
    const [status, setStatus] = useState([])
    const [message, setMessage] = useState('')
    const [showVehicleDriver, setShowVehicleDriver] = useState(false)
    const [showBroadcastDetails, setShowBroadcastDetails] = useState(false)
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_BASE_URL}/transporter-allocation/orders/status/history?order_id=${props.vendor_order_id}&customer_no=${customerNo}&user_id=${userId}`)
            .then(function (response) {
                if (response.data.data && response.data.data.length > 0) {
                    setStatus(response.data.data)
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }, [props.vendor_order_id])

    const showVehicleDetails = (index) => {
        showVehicleDriver===index ?  setShowVehicleDriver(false) : setShowVehicleDriver(index)
    }
    const showBroadcastDetailsTable = (index) => {
        showBroadcastDetails===index ? setShowBroadcastDetails(false) :setShowBroadcastDetails(index)
    }
    return (
        <>
            <Modal
                open={true}
            >
                <Modal.Header className="p-bold-100">
                    <span>{statusHistory?.main_title||"History Status"}</span>
                </Modal.Header>
                <Modal.Content>
                    <Modal.Description>

                        <>
                            <Table stackable size="small" selectable>
                                <Table.Header className="w3-small">
                                    <Table.Row>
                                        <Table.HeaderCell className="p-bold-500">
                                            {statusHistory?.status || "Status"}
                                        </Table.HeaderCell>
                                        <Table.HeaderCell className="p-bold-500">
                                            {statusHistory?.updated_on || "Updated On"}
                                        </Table.HeaderCell>
                                        <Table.HeaderCell className="p-bold-500">
                                            {statusHistory?.vendor_name || "Vendor Name"}
                                        </Table.HeaderCell>
                                        <Table.HeaderCell className="p-bold-500">
                                            {statusHistory?.remarks || "Remarks"}
                                        </Table.HeaderCell>
                                        <Table.HeaderCell className="p-bold-500">
                                            {statusHistory?.created_by || "Created By"}
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                {
                                    status.map((data, index) =>
                                        <>
                                            <Table.Row key={index}>
                                                <Table.Cell className="fixedLength150">{data?.order_state?.allotment_text ? data.order_state.allotment_text : "NA"}{
                                                    ((data?.vehicle && data?.driver) || data?.broadcasted_vendors?.length > 0) &&
                                                    <Button className='ml-3' type="button" size="mini" basic icon onClick={()=> data?.broadcasted_vendors?.length > 0 ? showBroadcastDetailsTable(index) : showVehicleDetails(index)}><Icon name="eye" /></Button>
                                                }</Table.Cell>
                                                <Table.Cell className="fixedLength150">{data?.timestamp ? moment(data.timestamp).local().format(DDMMYYYYHHmmss) : "NA"}</Table.Cell>
                                                <Table.Cell className="fixedLength150">{data?.vendor?.vendor_name ? data.vendor.vendor_name : "NA"}</Table.Cell>
                                                <Table.Cell className="fixedLength150">{data?.remarks ? data.remarks : "NA"}</Table.Cell>
                                                <Table.Cell className="fixedLength150">{data?.created_by?.realName ? data?.created_by?.realName : "NA"}</Table.Cell>
                                            </Table.Row>

                                            {showVehicleDriver===index && data?.vehicle && data?.driver &&
                                                <Table.Row>
                                                    <Table stackable selectable className='m-2'>
                                                        <Table.Header className="w3-small">
                                                            <Table.Row>
                                                                <Table.HeaderCell className="p-bold-500">
                                                                    {statusHistory?.vehicle_no || "Vehicle Number"}
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell className="p-bold-500">
                                                                    {statusHistory?.driver_name || "Driver Name"}
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell className="p-bold-500">
                                                                    {statusHistory?.driver_no || "Driver Number"}
                                                                </Table.HeaderCell>
                                                            </Table.Row>
                                                            <Table.Row key={index}>
                                                                <Table.Cell className="fixedLength150">{data?.vehicle?.vehicle_number ? data.vehicle.vehicle_number : "NA"}</Table.Cell>
                                                                <Table.Cell className="fixedLength150">{data?.driver?.name ? data.driver.name : "NA"}</Table.Cell>
                                                                <Table.Cell className="fixedLength150">{data?.driver?.contact_number ? data.driver.contact_number : "NA"}</Table.Cell>
                                                            </Table.Row>

                                                        </Table.Header>

                                                    </Table>
                                                </Table.Row>}

                                            {showBroadcastDetails===index && data?.broadcasted_vendors?.length > 0 &&
                                                <Table.Row>
                                                    <Table stackable selectable className='m-2'>
                                                        <Table.Header className="w3-small">
                                                            <Table.Row>
                                                                <Table.HeaderCell className="p-bold-500">
                                                                    {statusHistory?.vendor_name || "Vendor name"}
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell className="p-bold-500">
                                                                    {statusHistory?.created_on || "Created on"}
                                                                </Table.HeaderCell>
                                                                <Table.HeaderCell className="p-bold-500">
                                                                    {statusHistory?.accepted_on || "Accepted on"}
                                                                </Table.HeaderCell>
                                                            </Table.Row>

                                                            {data?.broadcasted_vendors.map((broadcast, i) =>

                                                                <>
                                                                    <Table.Row key={index}>
                                                                        <Table.Cell className="fixedLength150">{broadcast?.vendor_name ? broadcast.vendor_name : "NA"}</Table.Cell>
                                                                        <Table.Cell className="fixedLength150">{broadcast?.created_on ? moment(broadcast.created_on).local().format(DDMMYYYYHHmmss): "NA"}</Table.Cell>
                                                                        <Table.Cell className="fixedLength150">{broadcast?.accepted_on ? moment(broadcast.accepted_on).local().format(DDMMYYYYHHmmss) : "NA"}</Table.Cell>
                                                                    </Table.Row>
                                                                </>
                                                            )}
                                                        </Table.Header>

                                                    </Table>
                                                </Table.Row>}
                                        </>
                                    )
                                }

                            </Table>
                        </>

                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        type="button"
                        onClick={() => props.handleClose(true)}
                        size="mini"
                        color="olive"
                    >
                        Close
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    )
}

export default StatusHistory
